import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import ShadowBox from '../common/ShadowBox'
import ShadowBoxTitle from '../common/ShadowBoxTitle'
import PictureDragPanel from './PictureDragPanel'
import PictureGroup from './PictureGroup'
import TextEditor from './TextEditor'
import style from './style.module.less'

@inject('sessionPictureStore')
@observer
export default class extends Component {
  render() {
    const store = this.props.sessionPictureStore
    // setmealListStatus true 时 为正常编辑 false 为引导页状态
    const { pictureListPreview, pictureList /* setmealListStatus */ } = store
    return (
      <div className={style.content} id="sessionScrollWrapper">
        <ShadowBox>
          <ShadowBoxTitle store={store} />
          {/* {setmealListStatus && !!pictureList.length ? ( */}
          {/* {!!pictureList.length ? (    // 图文列表。其实不该叫PictureGroup 因为包含文本内容 */}
          <PictureGroup store={store} />
          {/* ) : null} */}
          {/* <Tips store={store} /> */}
        </ShadowBox>
        {/* 选中文本时右侧的文本编辑框 */}
        <div className={style.contentText}>
          {pictureList.some(el => el.kind == 3 && el.status) && (
            // setmealListStatus && <TextEditor store={store} />
            <TextEditor store={store} />
          )}
        </div>
        {!!pictureListPreview.length && <PictureDragPanel store={store} />}
        {/* 悬浮添加图片文字区 */}
        {/* <Editor store={store} /> */}
      </div>
    )
  }
}
